import styled from "styled-components";
import { SolutionColorVariables } from "@smartsuite/types";

export const SimpleSliderStyled = styled.div`
  padding: 0 40px;

  .slick-slider {
    padding-bottom: 64px;
  }

  .slick-dots {
    bottom: 36px;

    li {
      width: 16px;
      height: 16px;
      margin: 0;

      button {
        width: 16px;
        height: 16px;
        padding: 4px;

        &::before {
          width: 16px;
          height: 16px;
          font-size: 12px;
          line-height: 16px;
          color: ${SolutionColorVariables.sc1};
          opacity: 0.3;
        }
      }

      &.slick-active {
        button {
          &::before {
            color: ${SolutionColorVariables.sc1};
            opacity: 1;
          }
        }
      }
    }
  }
`;

export const SimpleSliderMessageStyled = styled.div`
  .simple-slider-message {
    &__subtitle {
      margin-bottom: 24px;
    }

    &__title {
      .title--xxxl {
        font-size: 38px;
        line-height: 48px;
      }
    }
  }

  strong {
    font-weight: 600;
  }
`;
